import { render, staticRenderFns } from "./capacitations.vue?vue&type=template&id=5b141e3f&scoped=true&lang=pug&"
import script from "./capacitations.vue?vue&type=script&lang=coffee&"
export * from "./capacitations.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b141e3f",
  null
  
)

export default component.exports